import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';

class JoinOrganizationPendingModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orgJoinResponseMessage: ""
		};
	}

	componentDidMount() {

	}

	render () {

		return (
			<Modal onHide={this.props.hideJoinOrganizationPendingModal} show={this.props.showJoinOrganizationPendingModal} aria-labelledby="ModalHeader">
            	<Modal.Header closeButton>
              		<Modal.Title id='ModalHeader'>Join Organization/Company Pending</Modal.Title>
            	</Modal.Header>
            	<Modal.Body>
					By submitting this new request to join {this.props.selectedOrgToJoin} your pending request to join {this.props.pendingRequestOrgName} will be canceled. Are you sure
					your want to proceed?
            	</Modal.Body>
            	<Modal.Footer>
              		<button className='btn btn-primary' onClick={this.props.sendRequestToJoinOrg} name="YES">
                		YES
              		</button>
              		<button className='btn btn-secondary' onClick={this.props.hideJoinOrganizationPendingModal} name="NO">
               		 	NO
              		</button>
            	</Modal.Footer>
          </Modal>
		)
	}
}

export default JoinOrganizationPendingModal;



// WEBPACK FOOTER //
// ./src/manageOrg/JoinOrganizationPendingModal.js